import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type {
  InputMaybe,
  InsertImpactMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertImpactDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface InsertImpactInput {
  Name: string;
  Rationale?: InputMaybe<string>;
  RatingGuidance?: InputMaybe<string>;
  LikelihoodAppetite?: InputMaybe<number>;
  CustomAttributeData?: InputMaybe<CustomAttributeData>;
  OwnerUserIds: string[];
  OwnerGroupIds: string[];
}

export const useInsertImpact = createMutationHook({
  name: 'insertImpact',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.impact.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertImpactInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.impact.impacts.queryKey(),
    trpc.frontend.impact.impactList.queryKey(),
    trpc.frontend.impact.impactCount.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertImpactMutation => ({
    insertImpactApi: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertImpactDocument,
  graphqlVariables: (input: InsertImpactInput) => ({ object: input }),
  evictFields: ['impact', 'impact_aggregate'],
});
